import React from 'react';

import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import Heading from '@tds/core-heading';

import {
  Thead,
  Td,
  Tr,
  Th
} from '../orderDetailsSection/ratePlans/components/css';
import getFormattedPricing from '../orderDetailsSection/utils';

const TrackerServices = ({ serviceData, serviceName }) => {
  if (!serviceData.length) return null;

  return (
    <table>
      <Thead>
        <Tr>
          <Th width="55%">{serviceName}</Th>
          <Th width="10%">Term</Th>
          <Th width="10%">Unit Price</Th>
          <Th width="10%">Unit</Th>
          <Th width="15%">Total monthly fee</Th>
        </Tr>
      </Thead>
      <tbody>
        {serviceData.map(data => {
          const {
            name,
            device,
            term,
            quantity,
            unitPrice,
            fiftyPercentInUS
          } = data;
          return (
            <Tr>
              <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
                <div>
                  <p>
                    {name} - {device}
                  </p>
                  {fiftyPercentInUS && <p>50% in US</p>}
                </div>
              </Td>
              <Td>{term}</Td>
              <Td>{getFormattedPricing(unitPrice)}</Td>
              <Td>{quantity}</Td>
              <Td>{getFormattedPricing(unitPrice * quantity)}</Td>
            </Tr>
          );
        })}
      </tbody>
    </table>
  );
};

TrackerServices.propTypes = {
  serviceName: PropTypes.string.isRequired,
  serviceData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      device: PropTypes.string,
      term: PropTypes.string,
      quantity: PropTypes.number,
      unitPrice: PropTypes.number,
      fiftyPercentInUS: PropTypes.bool
    })
  ).isRequired
};

const SummaryRatePlan = ({ orderData, total }) => {
  const {
    fleetTrackingServices,
    assetTrackingServices,
    videoTelematicServices
  } = orderData;

  return (
    <>
      {total === 0 && <h4>No Rateplans Selected</h4>}
      <Box between={3}>
        <Heading level="h4">Rate Plan</Heading>
        <Box>
          <TrackerServices
            serviceData={fleetTrackingServices}
            serviceName="Fleet Tracking Service"
          />
          <TrackerServices
            serviceData={assetTrackingServices}
            serviceName="Asset Tracking Service"
          />
          <TrackerServices
            serviceData={videoTelematicServices}
            serviceName="Video Telematic Service"
          />
          <div
            style={{
              background: '#f4f4f4',
              border: '1px solid #e3e3e3',
              display: 'flex',
              justifyContent: 'space-between',
              padding: '1rem 3rem'
            }}
          >
            <p style={{ marginLeft: '16rem', fontWeight: '600' }}>Total</p>
            <p style={{ marginRight: '0.65rem', fontWeight: '600' }}>
              {getFormattedPricing(total)}
            </p>
          </div>
        </Box>
      </Box>
    </>
  );
};

SummaryRatePlan.propTypes = {
  orderData: PropTypes.shape({
    fleetTrackingServices: PropTypes.array,
    assetTrackingServices: PropTypes.array,
    videoTelematicServices: PropTypes.array
  }).isRequired,
  total: PropTypes.number.isRequired
};

export default SummaryRatePlan;
